import { render, staticRenderFns } from "./BasicInfoTables.vue?vue&type=template&id=19f22f07&scoped=true&"
import script from "./BasicInfoTables.vue?vue&type=script&lang=js&"
export * from "./BasicInfoTables.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoTables.vue?vue&type=style&index=0&id=19f22f07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f22f07",
  null
  
)

export default component.exports